import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModelConfigurationComponent } from './components/model-configuration/model-configuration.component';
@NgModule({
    imports: [
        NgbModule,
        CommonModule,
        SharedModule,
        MaterialModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
    ],
    declarations: [ModelConfigurationComponent],
    exports: [ModelConfigurationComponent],
})
export class SkillArchitectureModule {}
